import { GlassCard } from "@/components/GlassCard";
import { fmtUSD } from "@/lib/format";
import { TrendingUp } from "lucide-react";

const BRACKETS = [
  { rate: 10, min: 0,     max: 10000 },
  { rate: 15, min: 10000, max: 20000 },
  { rate: 20, min: 20000, max: 30000 },
  { rate: 25, min: 30000, max: null  },
];

export function NextCommission({ data }) {
  if (!data) return null;
  const total = data.total_sales_amount;
  const idx = data.tier_index - 1;
  const current = BRACKETS[idx];
  const nextTier = BRACKETS[idx + 1];
  const pct = Math.min(100, (total / 30000) * 100);
  const toNext = data.next_threshold ? data.next_threshold - total : 0;

  return (
    <GlassCard data-testid="next-commission">
      <div className="flex items-start justify-between mb-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl glass-pill flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-sky-300" strokeWidth={2.2} />
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">Commission Rate</p>
            <p className="font-heading text-2xl font-bold text-white leading-tight">
              {current.rate}% <span className="text-sm font-medium text-white/55">this month</span>
            </p>
          </div>
        </div>
        {nextTier ? (
          <div className="text-right">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">Next: {nextTier.rate}%</p>
            <p className="font-heading text-xl font-bold text-sky-300 tabular-nums leading-tight mt-0.5">
              {fmtUSD(toNext)}
            </p>
            <p className="text-[11px] text-white/50">to unlock</p>
          </div>
        ) : (
          <div className="text-right">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">Top rate</p>
            <p className="font-heading text-xl font-bold text-emerald-300 leading-tight mt-0.5">Unlocked</p>
          </div>
        )}
      </div>

      <div className="relative">
        <div className="h-2.5 rounded-full bg-white/10 overflow-hidden border border-white/15">
          <div
            className="h-full bg-gradient-to-r from-sky-400 to-blue-500 rounded-full"
            style={{ width: `${pct}%` }}
            data-testid="commission-progress-bar"
          />
        </div>
        <div className="flex justify-between text-[10px] text-white/50 mt-2 font-mono">
          <span>10% · $0</span>
          <span>15% · $10k</span>
          <span>20% · $20k</span>
          <span>25% · $30k</span>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="text-white/55">Monthly sales</span>
        <span className="font-heading font-semibold text-white tabular-nums">{fmtUSD(total)}</span>
      </div>
    </GlassCard>
  );
}
